import React from "react";
import OrdersSubTabs from "../Order/OrdersSubTabs";
import OrderMobileCardShell from "../Order/OrderMobileCardShell";

/** In sync with desktop `<thead>` column count */
const ORDER_DESKTOP_COL_COUNT = 8;

const TX_ROWS = [
  {
    id: 1,
    sr: 1,
    date: "09/04/2026",
    time: "11:45 AM",
    txType: "DEPOSIT",
    currency: "USDT",
    chain: "TRC20",
    amount: "500.25",
    txHash: "0x1a2b3c4d...9f8e7d",
    status: "COMPLETED",
    statusClass: "text-success",
  },
  {
    id: 2,
    sr: 2,
    date: "08/04/2026",
    time: "03:20 PM",
    txType: "WITHDRAWAL",
    currency: "BTC",
    chain: "Bitcoin",
    amount: "0.015",
    txHash: "bc1qxy2k...g9hm",
    status: "PENDING",
    statusClass: "text-warning",
  },
  {
    id: 3,
    sr: 3,
    date: "07/04/2026",
    time: "09:10 AM",
    txType: "DEPOSIT",
    currency: "ETH",
    chain: "ERC20",
    amount: "2.5",
    txHash: "0xdeadbeef...a1b2c3",
    status: "SUCCESS",
    statusClass: "text-success",
  },
  {
    id: 4,
    sr: 4,
    date: "06/04/2026",
    time: "06:00 PM",
    txType: "WITHDRAWAL",
    currency: "SOL",
    chain: "Solana",
    amount: "25",
    txHash: "5VERv8NMv...4BUP",
    status: "REJECTED",
    statusClass: "text-danger",
  },
];

function txTypeHeroSubtitle(type) {
  const u = String(type || "").toUpperCase();
  const isWithdraw = u.includes("WITHDRAW");
  return (
    <span className={`orders-mobCard__subtype ${isWithdraw ? "orders-mobCard__subtype--sell" : "orders-mobCard__subtype--buy"}`.trim()}>
      {type}
    </span>
  );
}

const TransactionHistory = () => (
  <>
    <div className="dashboard_right">
      <div className="dashboard_listing_section2 Overview_mid">
        <div className="listing_left_outer full_width transaction_history_t desktop_view2 so-desktopWrap">
          <main className="so-page" aria-labelledby="so-asset-history-title">
            <h1 id="so-asset-history-title" className="so-page__title">
              Asset History
            </h1>

            <OrdersSubTabs
              tabs={[
                { label: "Transactions", to: "/user_profile/orders/transaction_history" },
                { label: "Deposit", to: "/user_profile/orders/deposit_history" },
                { label: "Withdraw", to: "/user_profile/orders/withdraw_history" },
                { label: "Transfer", to: "/user_profile/orders/transfer" },
                { label: "Swap", to: "/user_profile/orders/swap_history" },
                { label: "Wallet Transfer", to: "/user_profile/orders/wallet_transfer_History" },
                { label: "Earning", to: "/user_profile/orders/earning_plan_history" },
                { label: "Bonus", to: "/user_profile/orders/bonus_history" },
              ]}
            />

            <div className="so-toolbar so-toolbar--stack" role="search" aria-label="Asset history tools">
              <div className="so-toolbar__right">
                <div className="searchBar custom-tabs">
                  <i className="ri-search-2-line" aria-hidden="true" />
                  <input type="search" className="custom_search" placeholder="Search Crypto" defaultValue="" />
                </div>
                <button
                  type="button"
                  className="searchBar custom-tabs"
                  data-bs-toggle="modal"
                  data-bs-target="#exportWalletHistoryModal"
                  title="Export Deposit/Withdrawal History"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-download-2-line" aria-hidden="true" />
                </button>
              </div>
            </div>

            <div className="so-tableWrap">
              <table className="so-table">
                <thead>
                  <tr>
                    <th scope="col">Sr No</th>
                    <th scope="col">Date &amp; Time</th>
                    <th scope="col">Transaction Type</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Chain</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Tx Hash</th>
                    <th scope="col" className="right_td">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {TX_ROWS.map((r) => (
                    <tr key={r.id} className="cursor-pointer">
                      <td className="color-grey">
                        <small>{r.sr}</small>
                      </td>
                      <td>
                        <div className="c_view justify-content-start">
                          <span>
                            {r.date}
                            <small>{r.time}</small>
                          </span>
                        </div>
                      </td>
                      <td>{r.txType}</td>
                      <td>{r.currency}</td>
                      <td>{r.chain}</td>
                      <td className="so-num">{r.amount}</td>
                      <td>
                        <div className="d-flex align-items-center gap-1 flex-wrap">
                          <span>{r.txHash}</span>
                          <button type="button" className="btn btn-sm btn-icon p-0" title="Copy Tx Hash" aria-label="Copy Tx Hash">
                            <i className="ri-file-copy-line" aria-hidden="true" />
                          </button>
                        </div>
                      </td>
                      <td className={`right_td ${r.statusClass}`}>{r.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="hVPalX gap-2">
              <span>1-4 of 4</span>
              <div className="sc-eAKtBH gVtWSU">
                <button type="button" aria-label="First Page" className="sc-gjLLEI kuPCgf">
                  <i className="ri-skip-back-fill text-white" aria-hidden="true" />
                </button>
                <button type="button" aria-label="Previous Page" className="sc-gjLLEI kuPCgf">
                  <i className="ri-arrow-left-s-line text-white" aria-hidden="true" />
                </button>
                <button type="button" aria-label="Next Page" className="sc-gjLLEI kuPCgf">
                  <i className="ri-arrow-right-s-line text-white" aria-hidden="true" />
                </button>
                <button type="button" aria-label="Last Page" className="sc-gjLLEI kuPCgf">
                  <i className="ri-skip-forward-fill text-white" aria-hidden="true" />
                </button>
              </div>
            </div>
          </main>
        </div>

        <div className="order_history_mobile_view so-mobile">
          <h2 className="so-mobile__title">Asset History</h2>
          <OrdersSubTabs
            tabs={[
              { label: "Transactions", to: "/user_profile/orders/transaction_history" },
              { label: "Deposit", to: "/user_profile/orders/deposit_history" },
              { label: "Withdraw", to: "/user_profile/orders/withdraw_history" },
              { label: "Transfer", to: "/user_profile/orders/transfer" },
              { label: "Swap", to: "/user_profile/orders/swap_history" },
              { label: "Wallet Transfer", to: "/user_profile/orders/wallet_transfer_History" },
              { label: "Earning", to: "/user_profile/orders/earning_plan_history" },
              { label: "Bonus", to: "/user_profile/orders/bonus_history" },
            ]}
          />
          <div className="so-mobile__toolbar">
            <div className="d-flex flex-row justify-content-end align-items-center gap-2 w-100">
              <button
                type="button"
                className="searchBar custom-tabs"
                data-bs-toggle="modal"
                data-bs-target="#exportWalletHistoryModal"
                title="Export Deposit/Withdrawal History"
                style={{ cursor: "pointer" }}
              >
                <i className="ri-download-2-line" aria-hidden="true" />
              </button>
              <div className="searchBar custom-tabs">
                <i className="ri-search-2-line" aria-hidden="true" />
                <input type="search" className="custom_search" placeholder="Search Crypto" defaultValue="" />
              </div>
            </div>
          </div>

          {TX_ROWS.map((r) => (
            <OrderMobileCardShell
              key={`m-${r.id}`}
              desktopColumnCount={ORDER_DESKTOP_COL_COUNT}
              popupTitle="Transaction details"
              heroPrimary={r.currency}
            >
              <div className="so-mobileCard__row">
                <span>Sr No</span>
                <span className="so-num">{r.sr}</span>
              </div>
              <div className="so-mobileCard__row">
                <span>Date &amp; Time</span>
                <span className="so-num">
                  {r.date}
                  <small className="d-block">{r.time}</small>
                </span>
              </div>
              <div className="so-mobileCard__row">
                <span>Transaction Type</span>
                <span>{txTypeHeroSubtitle(r.txType)}</span>
              </div>
              <div className="so-mobileCard__row">
                <span>Chain</span>
                <span className="so-num">{r.chain}</span>
              </div>
              <div className="so-mobileCard__row">
                <span>Amount</span>
                <span className="so-num">{r.amount}</span>
              </div>
              <div className="so-mobileCard__row">
                <span>Tx Hash</span>
                <span className="so-num d-flex align-items-center gap-1 flex-wrap justify-content-end">
                  <span>{r.txHash}</span>
                  <button type="button" className="btn btn-sm btn-icon p-0" title="Copy Tx Hash" aria-label="Copy Tx Hash">
                    <i className="ri-file-copy-line" aria-hidden="true" />
                  </button>
                </span>
              </div>
              <div className="so-mobileCard__row">
                <span>Status</span>
                <span className={r.statusClass}>{r.status}</span>
              </div>
            </OrderMobileCardShell>
          ))}

          <div className="hVPalX gap-2 mt-3">
            <span>1-4 of 4</span>
            <div className="sc-eAKtBH gVtWSU">
              <button type="button" aria-label="First Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-skip-back-fill text-white" aria-hidden="true" />
              </button>
              <button type="button" aria-label="Previous Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-arrow-left-s-line text-white" aria-hidden="true" />
              </button>
              <button type="button" aria-label="Next Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-arrow-right-s-line text-white" aria-hidden="true" />
              </button>
              <button type="button" aria-label="Last Page" className="sc-gjLLEI kuPCgf">
                <i className="ri-skip-forward-fill text-white" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade search_form export_modal"
        id="exportWalletHistoryModal"
        tabIndex="-1"
        aria-labelledby="exportWalletHistoryModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exportWalletHistoryModalLabel">
                Export Deposit/Withdrawal History
              </h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body export_modal_body">
              <div className="export_section">
                <label className="export_label">Transaction Type</label>
                <div className="export_btn_group">
                  <button type="button" className="export_btn active">
                    All
                  </button>
                  <button type="button" className="export_btn">
                    Deposit
                  </button>
                  <button type="button" className="export_btn">
                    Withdrawal
                  </button>
                </div>
              </div>

              <div className="export_section">
                <label className="export_label">Select Time Period</label>
                <div className="export_btn_group export_presets">
                  <button type="button" className="export_btn">
                    Last 24 hours
                  </button>
                  <button type="button" className="export_btn">
                    2 Weeks
                  </button>
                  <button type="button" className="export_btn">
                    1 Month
                  </button>
                  <button type="button" className="export_btn">
                    3 Months
                  </button>
                  <button type="button" className="export_btn">
                    6 Months
                  </button>
                  <button type="button" className="export_btn active">
                    Customize
                  </button>
                </div>
                <div className="export_date_range">
                  <input type="date" className="export_date_input" defaultValue="2026-03-09" />
                  <span className="export_date_arrow">
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                  <input type="date" className="export_date_input" defaultValue="2026-04-09" />
                </div>
                <small className="export_note">* Up to 10,000 data can be generated each time.</small>
              </div>

              <div className="export_section">
                <label className="export_label">Format</label>
                <div className="export_btn_group">
                  <button type="button" className="export_btn active">
                    PDF
                  </button>
                  <button type="button" className="export_btn">
                    Excel
                  </button>
                </div>
              </div>

              <div className="export_section export_actions">
                <button type="button" className="export_submit_btn">
                  Export
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default TransactionHistory;
